import { Stack, TextField, Typography } from "@mui/material";
import { SaveBar } from "@shared";
import { FormikProps } from "formik";

import { CalculationParameterResponse } from "@/api";
import {
  ParameterEntryFormValues,
  ParameterFormValues,
} from "@/pages/system-settings/tabs/calculation-parameters/CalculationParametersSettings.types";
import { useTranslation } from "@/translations";

import { ParameterEntriesTable } from "../parameter-entries-table/ParameterEntriesTable";

interface Props {
  parameter: CalculationParameterResponse | null;
  formik: FormikProps<ParameterFormValues>;
  isSaving: boolean;
  onAddEntry: () => void;
  onRemoveNewEntry: (index: number) => void;
  onDeleteEntry: (entry: ParameterEntryFormValues) => void;
}

export function ParameterEditor({ parameter, formik, isSaving, onAddEntry, onRemoveNewEntry, onDeleteEntry }: Props) {
  const { t } = useTranslation();

  if (parameter === null) {
    return (
      <Stack flex={1} alignItems="center" justifyContent="center">
        <Typography color="text.secondary">{t("settings.parameters.noParameterSelected")}</Typography>
      </Stack>
    );
  }

  return (
    <Stack component="form" onSubmit={formik.handleSubmit} flex={1} minHeight={0} gap={1}>
      <Stack flex={1} minHeight={0} gap={2} pt={1}>
        <TextField
          label={t("settings.parameters.key")}
          value={parameter.technicalKey}
          disabled
          size="small"
          fullWidth
        />

        <ParameterEntriesTable
          parameter={parameter}
          formik={formik}
          isSaving={isSaving}
          onAdd={onAddEntry}
          onRemoveNew={onRemoveNewEntry}
          onDelete={onDeleteEntry}
        />
      </Stack>

      <SaveBar
        resetLabel={t("common.resetChanges")}
        onReset={formik.handleReset}
        resetDisabled={!formik.dirty || isSaving}
        saveLabel={t("common.save")}
        saveDisabled={!formik.dirty || isSaving}
        sx={{ px: 0 }}
      />
    </Stack>
  );
}
